import { useMessagingNotificationsStore } from '@/shared/stores/messagingNotifications'

/**
 * Legacy parity: play notification.mp3 on new inbound SMS/MMS.
 * @see legacy/resources/views/messaging/livewire/messages.blade.php
 */
let audio: HTMLAudioElement | null = null

function getAudio(): HTMLAudioElement {
  if (!audio) {
    audio = new Audio('/audio/notification.mp3')
  }
  return audio
}

export function playNewMessageAlert(): void {
  try {
    const el = getAudio()
    el.currentTime = 0
    void el.play().catch(() => {
      // Browser autoplay policy — ignore until user has interacted with the page
    })
  } catch {
    // Audio unavailable — no-op
  }
}

/** Plays only when the user preference allows it (Profile / Notifications mute). */
export function playNewMessageAlertIfEnabled(): void {
  const store = useMessagingNotificationsStore()
  if (!store.soundEnabled) return
  playNewMessageAlert()
}
